"use_strict";
import $ from "jquery";
import ItcModal from "./modal";
import Choices from "choices.js";
import {Maskito} from '@maskito/core';
import { phoneMask, getOptions } from './micromask';

document.addEventListener("DOMContentLoaded", () => {
  let is_mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ),
    countBlockTop = $(".left-part").length ? $(".left-part").offset().top : "",
    windowHeight = window.innerHeight,
    windowWidth = window.innerWidth,
    show = true;

    if (window.location.pathname === '/') {
      $(window).scroll(function () {
        if (
          show &&
          countBlockTop - windowHeight < $(window).scrollTop() + windowHeight
        ) {
          show = false;

          $(".left-part").spincrement({
            from: 1,
            duration: 3000,
            decimalPoint: ",",
          });
        }
        document.documentElement.style.setProperty(
          "--scroll-y",
          `${window.scrollY}px`
        );
      });
    }


  function reqValCheck(field) {
    let createSpan = document.createElement("span");
    createSpan.classList.add("wpcf7-not-valid-tip");
    createSpan.innerHTML = "Пожалуйста, заполните это поле.";
    let parent = field.parentNode;
    if (!parent.querySelector(".wpcf7-not-valid-tip")) {
      parent.insertBefore(createSpan, field.nextSibling);
    } else if (
      field.nextSibling ||
      parent.querySelector(".wpcf7-not-valid-tip")
    ) {
      parent.querySelector(".wpcf7-not-valid-tip").classList.remove("hidden");
    }
    field.style.borderBottom = "1px solid red";

    field.addEventListener("input", (e) => {
      let p = field.parentNode;
      field.style = "";
      if (p.querySelector(".wpcf7-not-valid-tip")) {
        p.querySelector(".wpcf7-not-valid-tip").classList.add("hidden");
      }
    });
  }

  function openModalById(id) {
    console.log(id);
    const allBtn = document.getElementsByClassName("button");
    const currentBtn = [].filter.call(allBtn, function (btn) {
      return (
        btn.getAttribute("data-form") && btn.getAttribute("data-form") === id
      );
    });

    currentBtn[0].click();
  }

  const allButtons = document.getElementsByClassName("button-modal");
  const modal = new ItcModal();
  let selectsArr = [];

  [...allButtons].map((btn) => {

    btn.addEventListener("click", () => {
      modal.setTitle(btn.getAttribute("name"));
      modal.setBody(btn.dataset.form);
      const bodyWidthForm = modal.getBody();
      /* Кастомизация <select> choices.js. */
      if (bodyWidthForm.querySelectorAll("select")) {
        const selects = bodyWidthForm.querySelectorAll("select");
        selects.forEach((select) => {
          const newSelect = new Choices(select, {
            allowHTML: true,
            itemSelectText: "Выбрать",
            searchEnabled: false,
            shouldSort: false,
          });
          // selectsArr.push(newSelect);
        });
      }
      wpcf7.init(bodyWidthForm.querySelector('.wpcf7 form' ));
      modal.show();
    });
  })
  // async function getContactForm(data) {
  //   try {
  //     // Формируем запрос
  //     const response = await fetch("/wp-content/themes/autolocman-official/functions.php", {
  //       method: "POST",
  //       body: data,
  //     });
  //     // проверяем, что ответ есть
  //     if (!response.ok)
  //       throw `Ошибка при обращении к серверу: ${response.status}`;
  //     // проверяем, что ответ действительно JSON
  //     const contentType = response.headers.get("content-type");
  //     if (!contentType || !contentType.includes("application/json")) {
  //       throw "Ошибка обработки. Ответ не JSON";
  //     }
  //     // обрабатываем запрос
  //     const json = await response.json();
  //     if (json.result === "success") {
  //       // в случае успеха
  //       console.log(json);
  //       return json;
  //     } else {
  //       // в случае ошибки
  //       console.log(json);
  //       throw json.info;
  //     }
  //   } catch (error) {
  //     // обработка ошибки
  //     console.log(error);
  //   }
  // }

  // const formData = new FormData();
  // formData.append('id', '07604cb');
  // console.log(formData);
  // for (var key of formData.keys()) {
  //   console.log(key, formData.get(key));
  // }
  // const form = getContactForm(formData).then(formHTML);
  // console.log(form);


  // const createModal = [...allButtons].forEach((btn) => {
  //   if (btn.getAttribute("data-form")) {
  //     // Получаем html модального окна из футера по id контактной формы
  //     if (document.getElementById(btn.getAttribute("data-form"))) {
  //       const formContent = document.getElementById(
  //         btn.getAttribute("data-form")
  //       ).children[0];
  //       const cloneContent = formContent.cloneNode(true);
  //       const formResponse = document.createElement("span");
  //       formResponse.classList.add("form-response", "hidden");

  //       const modal = new ItcModal({
  //         title: btn.getAttribute("name"),
  //       });

  //       const body = modal.getBody();
  //       const modalOverlay = modal.getBackdrop();
  //       let newBody = "";

  //       if (body.querySelector("#modal-content")) {
  //         newBody = body.querySelector("#modal-content");
  //         newBody.append(cloneContent);
  //       }
  //       const form = newBody ? newBody.children[0] : "";

  //       const submitParent = form.querySelector(
  //         'input[type="submit"]'
  //       ).parentNode;
  //       submitParent.insertBefore(formResponse, submitParent.lastChild);

  //       // Ссылка на авто.
  //       if (btn.getAttribute("value")) {
  //         if (form.querySelector(".form-title")) {
  //           form.querySelector(".form-title").innerText +=
  //             " " + btn.getAttribute("value");
  //         }

  //         if (form.querySelector(".form-auto")) {
  //           let thisLoc = window.location.href;
  //           form.querySelector(".form-auto").innerHTML =
  //             "<a href=" +
  //             thisLoc +
  //             "> Ссылка на авто " +
  //             btn.getAttribute("value") +
  //             "</a>";
  //         }
  //       }

  //       /* Маски ввода. */
  //       if (form.querySelector("input.wpcf7-tel")) {
  //         const tel = form.querySelectorAll("input.wpcf7-tel");
  //         const telInput = phoneMask(tel[0]);
  //       }

  //       if (form.querySelector("input.auto-year")) {
  //         const year = form.querySelectorAll("input.auto-year");
  //         const yearInput = new Maskito(year[0], getOptions('year', ' г.')); 
  //       }

  //       if (form.querySelector("input.amount")) {
  //         const sum = form.querySelectorAll("input.amount");
  //         const sumInput = new Maskito(sum[0], getOptions('money',  ' ₽')); 
  //       }

  //       /* Кастомизация <select> choices.js. */
  //       if (form.querySelectorAll("select")) {
  //         const selects = form.querySelectorAll("select");
  //         selects.forEach((select) => {
  //           const newSelect = new Choices(select, {
  //             allowHTML: true,
  //             itemSelectText: "Выбрать",
  //             searchEnabled: false,
  //             shouldSort: false,
  //           });
  //           selectsArr.push(newSelect);
  //         });
  //       }

  //       btn.addEventListener("click", () => {
  //         modal.show();
  //       });
  //     }
  //   }
  // });

  // Отправка формы
  // if (document.querySelector("form.wpcf7-form")) {
  //   document.querySelectorAll("form.wpcf7-form").forEach((el) => {
  //     el.addEventListener("submit", async (e) => {
  //       // e.preventDefault();
  //       const isButton = e.submitter.classList.contains("button");
  //       switch (isButton) {
  //         case true:
  //           break;
  //         case false:
  //           console.log(1);
  //           let form = e.currentTarget,
  //             phone = form.querySelector('input[name="phone"]')
  //               ? form.querySelector('input[name="phone"]')
  //               : "",
  //             title = form.querySelector(".form-title")
  //               ? form.querySelector(".form-title")
  //               : "",
  //             linkToCar = form.querySelector(".form-auto")
  //               ? form.querySelector(".form-auto")
  //               : "",
  //             selects = form.querySelectorAll("select.wpcf7-form-control"),
  //             data = new FormData(),
  //             dataСhecking = true;

  //           title ? data.append("title", title.innerText) : "";
  //           linkToCar ? data.append("link-to-car", linkToCar.innerHTML) : "";

  //           form.querySelectorAll(".form-item").forEach((el) => {
  //             let currentVal;

  //             if (el.querySelector("input[name]")) {
  //               currentVal = el.querySelector("input[name]");
  //             }

  //             if (el.querySelector("select")) {
  //               currentVal = el.querySelector("select");
  //             }

  //             if (el.querySelector("textarea")) {
  //               currentVal = el.querySelector("textarea");
  //             }

  //             // Обработка обязательных полей и добавление в data.
  //             if (
  //               currentVal.getAttribute("aria-required") &&
  //               currentVal.value === ""
  //             ) {
  //               dataСhecking = false;

  //               if (currentVal.value === "") {
  //                 reqValCheck(currentVal);
  //               }
  //             } else if (dataСhecking) {
  //               data.append(currentVal.getAttribute("name"), currentVal.value);
  //             }
  //           });

  //           for (var key of data.keys()) {
  //             console.log(key, data.get(key));
  //           }

  //           if (!dataСhecking) {
  //             console.log(
  //               "Одно или несколько обязательных полей не заполнено."
  //             );
  //           } else {
  //             form
  //               .querySelector('input[type="submit"]')
  //               .setAttribute("disabled", "");
  //             form.querySelector(".wpcf7-spinner").style.visibility = "visible";

  //             try {
  //               // Формируем запрос
  //               const response = await fetch("/wp-content/src/form/form.php", {
  //                 method: "POST",
  //                 body: data,
  //               });
  //               // проверяем, что ответ есть
  //               if (!response.ok)
  //                 throw `Ошибка при обращении к серверу: ${response.status}`;
  //               // проверяем, что ответ действительно JSON
  //               const contentType = response.headers.get("content-type");
  //               if (!contentType || !contentType.includes("application/json")) {
  //                 throw "Ошибка обработки. Ответ не JSON";
  //               }
  //               // обрабатываем запрос
  //               const json = await response.json();
  //               if (json.result === "success") {
  //                 // в случае успеха
  //                 form.querySelector(".wpcf7-spinner").classList.add("hidden");
  //                 form
  //                   .querySelector(".form-response")
  //                   .classList.remove("hidden");
  //                 form.querySelector(".form-response").innerText =
  //                   "Заявка отправлена. Ожидайте обратного звонка.";
  //                 form.reset();
  //                 selectsArr.forEach((choice) => {
  //                   choice.setChoiceByValue(choice.config.choices[0].value);
  //                 });
  //                 form
  //                   .querySelector('input[type="submit"]')
  //                   .removeAttribute("disabled");
  //                 //   console.log(json.info);
  //               } else {
  //                 // в случае ошибки
  //                 form.querySelector(".wpcf7-spinner").classList.add("hidden");
  //                 form
  //                   .querySelector(".form-response")
  //                   .classList.remove("hidden");
  //                 form.querySelector(".form-response").innerText = json.info;

  //                 form
  //                   .querySelector('input[type="submit"]')
  //                   .removeAttribute("disabled");
  //                 console.log(json);
  //                 throw json.info;
  //               }
  //             } catch (error) {
  //               // обработка ошибки
  //               // console.log(error);
  //             }
  //           }
  //       }
  //     });
  //   });
  // }
});
